<template>
  <div class="toc">
    <div class="header">
      <div class="notice">
        <div class="notice-inner">
          <div class="marquee-container">
            <span :style="{'animation-duration': remindText.length + 's'}">{{remindText}}</span>
          </div>
        </div>
      </div>
      <div class="logo" v-if="currOrg">
        <img src="../assets/logo.png">
        <span>{{currOrg.branchName}}</span>
      </div>
      <div class="datetime">{{currentTime}}</div>
    </div>
    <div class="main">
      <div class="main-l">
        <div class="alert">
          <div class="block alert-list-container">
            <div class="block-header">SOS报警</div>
            <div class="block-content">
              <div class="summary">
                <span>今日处理：112次</span>
                <span>平均应答时间：5.3秒</span>
              </div>
              <div class="alert-list">
                <ul>
                  <li>
                    <span>07-20 17:32</span>
                    <span>一楼A133</span>
                    <span>拉绳报警</span>
                    <span class="error">未应答</span>
                  </li>
                  <li>
                    <span>07-22 12:02</span>
                    <span>一楼A134</span>
                    <span>拉绳报警</span>
                    <span>已处理</span>
                  </li>
                  <li>
                    <span>07-22 15:30</span>
                    <span>一楼A101</span>
                    <span>拉绳报警</span>
                    <span>已处理</span>
                  </li>
                  <li>
                    <span>07-24 08:15</span>
                    <span>二楼A112</span>
                    <span>拉绳报警</span>
                    <span>已处理</span>
                  </li>
                  <li>
                    <span>07-25 17:32</span>
                    <span>一楼A138</span>
                    <span>拉绳报警</span>
                    <span>已处理</span>
                  </li>
                  <li>
                    <span>07-26 17:32</span>
                    <span>一楼A123</span>
                    <span>拉绳报警</span>
                    <span>已处理</span>
                  </li>
                  <li>
                    <span>07-26 17:32</span>
                    <span>一楼A102</span>
                    <span>拉绳报警</span>
                    <span>已处理</span>
                  </li>
                  <li>
                    <span>07-27 17:32</span>
                    <span>一楼A135</span>
                    <span>拉绳报警</span>
                    <span>已处理</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="nurse-level-checkin-age">
          <div class="block">
            <div class="block-header">
              <span>护理等级分布</span>
              <span class="small">截至：{{getYesterday}}</span>
            </div>
            <div class="block-content">
              <div id="highchart-nurse"></div>
            </div>
          </div>
          <div class="block">
            <div class="block-header">
              <span>入住年龄分布</span>
              <span class="small">截至：{{getYesterday}}</span>
            </div>
            <div class="block-content">
              <div id="highchart-age"></div>
            </div>
          </div>
        </div>
        <div class="disease">
          <div class="chart-disease block">
            <div class="block-header">
              <span>入住长者慢病情况</span>
              <span>截至：{{getYesterday}}</span>
            </div>
            <div class="block-content" style="height: 280px;">
              <div id="highchart-disease"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-c">
        <div class="main-swiper" v-if="currOrg && currOrg.orgDetail">
          <div class="building-image">
            <swiper class="swiper" :options="swiperOption" :auto-update="true" @slideChangeTransitionEnd="slideChanged">
              <swiper-slide v-for="item in currOrg.orgDetail.attachList" :key="item.id">
                <img :src="`/ophApi/commonAttachDown/download?id=${item.id}`" alt="">
              </swiper-slide>
            </swiper>
          </div>
          <div class="bullets">
            <ul>
              <li v-for="(item, i) in currOrg.orgDetail.attachList" :key="item.id" :class="{'on': swiperIndex === i}">{{item.fileDescription}}</li>
            </ul>
          </div>
        </div>
        <div class="main-c-row">
          <div class="block today-stuff">
            <div class="block-header">今日值班人员</div>
            <div class="block-content">
              <ul>
                <li v-for="staff in staffList" :key="staff.id">
                  <div class="avatar">
                    <img :src="`/ophApi/commonAttachDown/download?id=${staff.avatarId}`" />
                  </div>
                  <div class="r">
                    <div class="worker-name"><span>{{staff.staffName}}</span>{{staff.post}}</div>
                    <div class="introduce">
                      {{staff.staffIntroduce}}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="block today-leader">
            <div class="block-header">值班领导</div>
            <div class="block-content">
              <ul>
                <li v-for="staff in principleList" :key="staff.id">
                  <div class="avatar">
                    <img :src="`/ophApi/commonAttachDown/download?id=${staff.avatarId}`" />
                  </div>
                  <div class="r">
                    <div class="worker-name"><span>{{staff.staffName}}</span>{{staff.post}}</div>
                    <div class="introduce">
                      {{staff.staffIntroduce}}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="block principle">
              <div class="block-header">
                <span>各部门在岗负责人</span>
              </div>
              <div class="block-content">
                <swiper class="swiper" :options="swiperOption" :auto-update="true">
                  <swiper-slide v-for="(item, i) in new Array(Math.ceil(deptPrincipleList.length / 3)).fill(1)" :key="i">
                    <ul>
                      <li v-for="staff in deptPrincipleList.slice(i * 3, i * 3 + 3)" :key="staff.id">
                        <div class="avatar">
                          <img :src="`/ophApi/commonAttachDown/download?id=${staff.avatarId}`" alt="">
                          <div>{{staff.staffName}}</div>
                        </div>
                        <div class="position">{{staff.post}}</div>
                        <div class="dscp">{{staff.staffIntroduce}}</div>
                      </li>
                    </ul>
                  </swiper-slide>
                </swiper>
              </div>
            </div>
        </div>
        <div class="main-c-bottom">
          <div class="block week-menu" v-if="menuList.length > 0">
            <div class="block-header">本周菜谱</div>
            <div class="block-content">
              <div class="weekdays">
                <div v-for="(weekday, i) in menuList" @click="selectedWeekdayIndex = i" :class="{'on': selectedWeekdayIndex === i}" :key="i">{{weekday.weekDayName}}</div>
              </div>
              <div class="meal-times">
                <div class="time-row" v-for="mealTime in menuList[selectedWeekdayIndex].typeList" :key="mealTime.menuType">
                  <div class="time">{{mealTime.menuTypeName}}</div>
                  <div class="dish-list">{{getDishName(mealTime.menuList)}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="block meal-top">
            <div class="block-header">最受欢迎菜品TOP10</div>
            <div class="block-content">
              <div id="highchart-meal-bar"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-r">
        <div class="employee-area">
          <div class="block">
            <div class="block-header">
              <span>区域人员分布</span>
            </div>
          </div>
        </div>
        <div class="week-act">
          <div class="block">
            <div class="block-header">本周活动回顾</div>
            <div class="block-content">
              <ul>
                <li v-for="act in actList" :key="act.id">
                  <div class="act-name">
                    <div>{{act.nameOfActivity}}</div>
                    <span>{{formatActTime(act.activityTime)}}</span>
                  </div>
                  <div class="act-place">
                    <div>活动地点：{{act.venue}}</div>
                    <span>参与人数：{{act.numberOfParticipants}}人</span>
                  </div>
                  <div class="act-imgs">
                    <!-- <div class="img" v-for="fileId in act.photo.split(',')" :key="fileId">
                      <img :src="`/ophApi/commonAttachDown/download?id=${fileId}`" alt="">
                    </div> -->
                    <swiper class="swiper" :options="swiperOption" :auto-update="true">
                      <swiper-slide v-for="(swiperSeq, i) in new Array(act.swiperLength).fill(1)" :key="i">
                        <div class="img" v-for="(fileIndex, j) in new Array(4).fill(1)" :key="j">
                          <img v-if="act.photoList[i * 4 + j]" :src="`/ophApi/commonAttachDown/download?id=${act.photoList[i * 4 + j]}`" alt="">
                        </div>
                      </swiper-slide>
                    </swiper>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="monitors block">
          <div class="block-header">
            <span>活动区域监控</span>
            <span></span>
          </div>
          <div class="block-content">
            <div class="bullet"></div>
            <swiper class="swiper" :options="monitorSwiperOpts" :auto-update="true" @slideChangeTransitionEnd="monitorSwiperChanged">
              <swiper-slide v-for="(group, i) in monitorList" :key="i">
                <div class="screenshots">
                  <div class="shot" v-for="(monitor, j) in group" :key="monitor.id" @click="openMonitorModal(monitor.url)">
                    <video :id="`monitor-${i}-${j}`" muted></video>
                    <div class="area">{{monitor.position}}</div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
    <m-dialog
      :show.sync="monitorShow"
      :no-head="true"
      @open="monitorOpen"
      @close="monitorClose"
      :append-to-body="true"
      width="1000px"
      >
      <video id="monitor-modal" controls></video>
    </m-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import Hls from 'hls.js'
import moment from 'moment'
import Highcharts from 'highcharts'
import Highcharts3d from 'highcharts/highcharts-3d'
import nurseChartOpts from '@/charts/nurse.js'
import ageChartOpts from '@/charts/age.js'
import diseaseChartOpts from '@/charts/disease.js'
import mealBarChartOpts from '@/charts/meal-bar.js'

Highcharts3d(Highcharts)

const weekdays = ['一', '二', '三', '四', '五', '六', '日'].map(str => `周${str}`)

// 监控轮播时长
const MONITOR_SLIDE_INTERVAL = 1000 * 60

export default {
  name: 'toc',
  data () {
    return {
      branchId: '',
      weekdays,
      currentTime: '',
      monitorTime: '',
      timer: null,

      currOrg: null,
      staffList: [],
      principleList: [],
      deptPrincipleList: [],
      actList: [], // 活动列表
      monitorList: [], // 监控列表
      menuList: [], // 周菜单列表

      // 跑马灯文字
      remindText: '',

      swiperIndex: 0,
      selectedWeekdayIndex: 0,
      monitorShow: false,
      player2: null,
      $videoModal: null,
      hlsModalSrc: '' // 弹窗监控地址
    }
  },
  async mounted () {
    this.selectedWeekdayIndex = moment().isoWeekday() === 7 ? 0 : moment().isoWeekday()
    this.branchId = this.$route.query.branchId
    // 右上角时间
    this.startTimer()
    const { data: res } = await this.$http.post('/biDataDaily/typeBeanList', {
      branchId: this.branchId,
      initZero: true
    })
    this.chartInfo = res.data
    const { data: orgRes } = await this.$http.get(`/biDataDaily/operateInfo?branchId=${this.branchId}`)
    this.currOrg = orgRes.data

    const { data: detailRes } = await this.$http({
      url: '/orgExtra/detail',
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: `id=${this.branchId}`
    })
    this.$set(this.currOrg, 'orgDetail', detailRes.data)

    Highcharts.chart('highchart-nurse', nurseChartOpts(this.getChartInfo('BI_NURSE_LV_DIS'), {
      plotOptions: {
        pie: {
          dataLabels: {
            format: '<b>{point.name}</b><br>{point.percentage:.1f} %',
            distance: 10,
            style: {
              fontSize: '6px'
            }
          }
        }
      }
    }))
    Highcharts.chart('highchart-age', ageChartOpts(this.getChartInfo('BI_AGE_DIS'), {
      plotOptions: {
        pie: {
          dataLabels: {
            format: '<b>{point.name}</b><br>{point.percentage:.1f} %',
            distance: 10,
            style: {
              fontSize: '6px'
            }
          }
        }
      }
    }))
    Highcharts.chart('highchart-disease', diseaseChartOpts(this.getChartInfo('BI_CD_TOP')))
    Highcharts.chart('highchart-meal-bar', mealBarChartOpts(this.getChartInfo('BI_DISH_TOP')))

    // 员工
    const { data: staffRes } = await this.$http.get(`/biServiceStaff/listBeans?branchId=${this.branchId}`)
    this.staffList = staffRes.data.find(item => item.staffType === 'DUTY_STAFF').staffList
    this.principleList = staffRes.data.find(item => item.staffType === 'DUTY_LEADER').staffList
    this.deptPrincipleList = staffRes.data.find(item => item.staffType === 'SERVICE_CARE').staffList

    // 左上角跑马灯
    /* const formData = new FormData()
    formData.append('codeTypeId', 997)
    const { data: remindRes } = await this.$http.post('/comn/codeValue/list', formData)
    if (remindRes.data.rows.length > 0) {
      this.remindText = remindRes.data.rows[0].nameCn
    } */
    this.remindText = this.currOrg.orgDetail.screenprompt || ''
    // 周菜单
    const { data: menuRes } = await this.$http.get(`/biBranchMenu/listBeans?branchId=${this.branchId}`)
    this.menuList = menuRes.data
    // 活动列表
    const { data: actRes } = await this.$http.get(`/activities/ActivitiesInfo?branchId=${this.branchId}`)
    actRes.data.forEach(act => {
      act.photoList = act.photo.split(',')
      act.swiperLength = Math.ceil(act.photoList.length / 4)
    })
    this.actList = actRes.data
    // 监控列表
    const { data: monitorRes } = await this.$http.get(`/surveillancelist/SurveillancelistInfo?branchId=${this.branchId}`)
    const monitorGroupCount = Math.ceil(monitorRes.data.length / 4)
    const monitorGroups = []
    for (let i = 0; i < monitorGroupCount; i++) {
      if (i < monitorGroupCount - 1) {
        monitorGroups.push(monitorRes.data.slice(i * 4, i * 4 + 4))
      } else {
        monitorGroups.push(monitorRes.data.slice(i * 4, monitorRes.data.length + 1))
      }
    }
    this.monitorList = monitorGroups

    this.$nextTick(() => {
      this.playMonitorGroup(0)
      this.monitorSwiperChanged()
    })

  },
  methods: {
    playMonitorGroup (i) {
      console.log(`start load monitor group  ${i}`)
      this.monitorList[i].forEach((monitor, j) => {
        if (monitor.player) {
          this.$el.querySelector(`#monitor-${i}-${j}`).play()
        } else {
          const hlsSrc = monitor.url
          const $video = this.$el.querySelector(`#monitor-${i}-${j}`)
          monitor.player = this.loadHls($video, hlsSrc)
          monitor.player.on(Hls.Events.MANIFEST_PARSED, () => {
            $video.play()
          })
        }
      })
    },
    pauseMonitorGroup (i) {
      console.log(`pause monitor group ${i}`)
      this.monitorList[i].forEach((monitor, j) => {
        if (monitor.player) {
          this.$el.querySelector(`#monitor-${i}-${j}`).pause()
        }
      })
    },
    monitorSwiperChanged ($swiper) {
      const index = $swiper ? $swiper.activeIndex : 0
      const lastIndex = this.monitorList.length - 1
      const prevIndex = index === 0 ? lastIndex : index - 1
      const nextIndex = index === lastIndex ? 0 : index + 1
      this.pauseMonitorGroup(prevIndex)
      setTimeout(() => {
        this.playMonitorGroup(nextIndex)
      }, Math.max(MONITOR_SLIDE_INTERVAL - 10000, 0))
    },
    slideChanged ($swiper) {
      this.swiperIndex = $swiper.activeIndex
    },
    getChartInfo (code) {
      if (this.chartInfo) {
        return this.chartInfo.find(item => item.typeCode === code)
      } else {
        return {}
      }
    },
    loadHls ($video, hlsSrc) {
      const hlsPlayer = new Hls({
        maxBufferSize: 1000 * 1000
      })
      hlsPlayer.loadSource(hlsSrc)
      hlsPlayer.attachMedia($video)
      hlsPlayer.on(Hls.Events.ERROR, (event, data) => {
        console.error(data)
      })
      return hlsPlayer
    },
    startTimer () {
      if (!this.timer) {
        this.timer = setInterval(() => {
          const now = moment()
          const datetime = now.format('YYYY-MM-DD HH:mm')
          const weekday = `星期${['一', '二', '三', '四', '五', '六', '日'][now.isoWeekday() - 1]}`
          this.currentTime = `${datetime} ${weekday}`
          this.monitorTime = now.format('YYYY-MM-DD HH:mm')
        }, 1000)
      }
    },
    formatActTime (datetimeStr) {
      if (datetimeStr) {
        const date = moment(datetimeStr)
        const weekday = `周${['一', '二', '三', '四', '五', '六', '日'][date.isoWeekday() - 1]}`
        return `${date.format('MM-DD HH:mm')} ${weekday}`
      } else {
        return ''
      }
    },
    getDishName (dishList) {
      return dishList.map(dish => dish.dishName).join('、')
    },
    openMonitorModal (hlsSrc) {
      this.hlsModalSrc = hlsSrc
      this.monitorShow = true
    },
    monitorOpen () {
      if (this.player2) {
        this.player2.destroy()
        this.player2 = null
      }
      this.$nextTick(() => {
        this.$videoModal = document.querySelector('#monitor-modal')
        this.player2 = this.loadHls(this.$videoModal, this.hlsModalSrc)
        this.player2.on(Hls.Events.MANIFEST_PARSED, () => {
          this.$videoModal.play()
        })
      })
    },
    monitorClose () {
      this.$videoModal.pause()
    }
  },
  computed: {
    getYesterday () {
      return moment().add('days', -1).format('YYYY-MM-DD')
    },
    swiperOption () {
      return {
        autoplay: {
          delay: 5000
        }
      }
    },
    monitorSwiperOpts () {
      return {
        autoplay: {
          delay: MONITOR_SLIDE_INTERVAL
        },
        allowTouchMove: false
      }
    }
  },
  beforeDestroy () {
    if (!this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    this.monitorList.forEach(group => {
      group.forEach(monitor => {
        if (monitor.player) {
          monitor.player.destroy()
        }
      })
    })
    if (this.player2) {
      this.player2.destroy()
    }
  }
}
</script>
<style lang="scss" scope>
.toc {
  width: 1920px;
  height: 1080px;
  background: url('../assets/home/bg.jpg');
  * {
    color: #fff;
  }
  .header {
    width: 100%;
    height: 135px;
    background: url('../assets/home/logokuang.png') no-repeat;
    background-position: center top;
    display: flex;
    > div {
      width: 33.33%;
    }
    .notice {
      display: flex;
      align-items: flex-end;
      padding: 0 0 10px 24px;
      box-sizing: border-box;
      font-weight: bold;
      color: #36c4ff;
      font-size: 18px;
      .notice-inner {
        width: 440px;
        overflow: hidden;
        text-align: left;
        .marquee-container {
          display: inline-block;
          span {
            display: inline-block;
            white-space: nowrap;
            animation: 4s linear 0s infinite normal notice-marquee;
          }
        }
      }
    }
    .logo {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 30px;
      flex: 1;
      img {
        width: 44px;
      }
      span {
        font-size: 40px;
        color: #08fbfb;
        margin-left: 12px;
        font-family: 'pangmenzhengdao';
        letter-spacing: 4px;
        max-width: 660px;
        line-height: 40px;
      }
    }
    .datetime {
      text-align: right;
      color: #fff;
      font-size: 24px;
      font-weight: bold;
      line-height: 116px;
      padding-right: 24px;
      box-sizing: border-box;
    }
  }
  .main {
    padding: 0 24px;
    display: flex;
    .main-l, .main-r {
      width: 455px;
    }
    .main-l {
      display: flex;
      flex-direction: column;
      .alert {
        height: 290px;
        .block {
          height: 100%;
          .block-content {
            .summary {
              width: 100%;
              line-height: 30px;
              background-color: #0c418d;
              display: flex;
              justify-content: space-between;
              padding: 0 20px;
              box-sizing: border-box;
              font-size: 12px;
            }
            .alert-list {
              padding: 10px 0;
              li {
                line-height: 26px;
                display: flex;
                padding: 0 5px;
                > span {
                  display: inline-block;
                  width: 25%;
                  text-align: center;
                  &:first-child {
                    text-align: left;
                  }
                  &:last-child {
                    text-align: right;
                  }
                  &.error {
                    color: #d04040;
                  }
                }
              }
            }
          }
        }
      }
      .nurse-level-checkin-age {
        margin-top: 10px;
        height: 235px;
        display: flex;
        .block {
          width: calc(50% - 5px);
          height: 100%;
          &:last-child {
            margin-left: 10px;
          }
          .block-content {
            > div {
              height: 100%;
            }
          }
        }
      }
      .disease {
        margin-top: 10px;
        flex: 1;
        .block {
          height: 100%;
          #highchart-disease {
            height: 100%;
          }
        }
      }
    }
    .main-c {
      width: 990px;
      margin-left: 20px;
      margin-right: 20px;
      .main-swiper {
        height: 455px;
        position: relative;
        .building-image {
          height: 100%;
          .swiper-container {
            width: 100%;
            height: 100%;
            .swiper-slide img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .bullets {
          position: absolute;
          bottom: 0;
          width: 100%;
          background: linear-gradient(to top, #061259, rgba(6, 18, 89, 0));
          z-index: 9;
          padding-bottom: 10px;
          ul {
            display: flex;
            justify-content: center;
            li {
              width: 100px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              color: #0ab2f3;
              cursor: pointer;
              &.on {
                background-color: #143185;
                color: #fff;
              }
            }
          }
        }
      }
      .main-c-row {
        margin-top: 10px;
        display: flex;
        width: 100%;
        height: 240px;
        .today-stuff, .today-leader {
          width: calc(25% - 7.5px);
          .block-content {
            li {
              display: flex;
              align-items: center;
              .avatar {
                width: 56px;
                height: 72px;
                overflow: hidden;
                border: 1px solid #07dfe4;
                border-radius: 3px;
                img {
                  width: 100%;
                  height: auto;
                }
              }
              .r {
                text-align: left;
                padding: 10px;
                flex: 1;
                font-size: 12px;
                .worker-name {
                  font-size: 16px;
                }
                .introduce {
                  height: 60px;
                  overflow: hidden;
                }
                span {
                  font-size: 18px;
                  color: #36c4ff;
                  margin-right: 5px;
                }
              }
            }
          }
        }
        .today-leader {
          margin-left: 10px;
        }
        .principle {
          width: calc(50% - 5px);
          margin-left: 10px;
          background: rgba(0, 90, 255, 0.3) url(../assets/home/specialist_bg.png) no-repeat;
          background-size: 100%;
          .block-content {
            padding-top: 30px;
          }
          ul {
            display: flex;
            justify-content: flex-start;
            li {
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              width: 33.33%;
              .avatar {
                width: 70px;
                height: 90px;
                position: relative;
                margin-top: 5px;
                overflow: hidden;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
                div {
                  position: absolute;
                  width: 100%;
                  height: 30px;
                  line-height: 30px;
                  text-align: center;
                  background: rgba(0, 0, 0, .4);
                  font-size: 15px;
                  bottom: 0;
                }
              }
              .position {
                font-size: 12px;
                line-height: 20px;
              }
              .dscp {
                font-size: 12px;
                line-height: 20px;
                height: 40px;
                padding: 0 5px;
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
              }
            }
          }
        }
      }
      .main-c-bottom {
        margin-top: 10px;
        height: 220px;
        display: flex;
        .block {
          width: calc(50% - 5px);
        }
        .week-menu {
          .block-content {
            .weekdays {
              display: flex;
              justify-content: space-around;
              div {
                cursor: pointer;
                width: 48px;
                line-height: 24px;
                color: #36c4ff;
                font-size: 14px;
                &.on {
                  background-color: #3668d5;
                  color: #fff;
                  border-radius: 15px
                }
              }
            }
            .meal-times {
              margin-top: 20px;
              .time-row {
                display: flex;
                line-height: 33px;
                background-color: rgba(40, 116, 255, .2);
                border-radius: 20px;
                margin-top: 10px;
                .time {
                  width: 64px;
                  background-color: #1e59c8;
                  border-radius: 20px;
                }
                .dish-list {
                  flex: 1;
                  margin-left: 15px;
                  text-align: left;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
        .meal-top {
          margin-left: 10px;
          #highchart-meal-bar {
            height: 100%;
          }
        }
      }
    }
    .main-r {
      .employee-area {
        height: 340px;
        .block {
          height: 100%;
        }
      }
      .week-act {
        width: 100%;
        height: 315px;
        margin-top: 10px;
        .block {
          height: 100%;
        }
        li {
          border-bottom: 1px solid #173fad;
          padding-bottom: 15px;
          padding-top: 5px;
          &:last-child {
            border-bottom: 0;
          }
          .act-name {
            display: flex;
            justify-content: space-between;
            div {
              color: #fff;
              font-size: 16px;
            }
            span {
              color: #36c4ff;
              font-size: 14px;
            }
          }
          .act-place {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
          }
          .act-imgs {
            margin-top: 5px;
            display: flex;
            height: 75px;
            width: 384px;
            .swiper-container {
              width: 100%;
              .swiper-slide {
                display: flex;
                width: 100%;
              }
              .img {
                width: calc(25% - 7.5px);
                margin-left: 10px;
                &:first-child {
                  margin-left: 0;
                }
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }
            }
          }
        }
      }
      .monitors {
        margin-top: 10px;
        height: 260px;
        .block-content {
          padding-bottom: 0;
          .screenshots {
            display: flex;
            flex-wrap: wrap;
            .shot {
              width: calc(50% - 5px);
              margin-right: 10px;
              margin-bottom: 10px;
              position: relative;
              &:nth-child(2n) {
                margin-right: 0;
              }
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
              video {
                width: 100%;
                height: auto;
              }
              .address {
                position: absolute;
                top: 10px;
                left: 10px;
              }
              .area {
                position: absolute;
                width: 100%;
                height: 30px;
                line-height: 30px;
                font-size: 14px;
                font-weight: bold;
                text-align: center;
                background-color: rgb(0, 90, 255, .5);
                bottom: 0;
              }
            }
          }
        }
      }
    }
  }

  .block {
    background-color: rgb(0, 90, 255, .3);
    display: flex;
    flex-direction: column;
    .block-header {
      display: flex;
      font-size: 14px;
      font-weight: bold;
      justify-content: space-between;
      padding: 0 10px;
      height: 35px;
      line-height: 35px;
      .small {
        font-size: 12px;
      }
    }
    .block-content {
      padding: 0 10px 10px 10px;
      flex: 1;
    }
  }

  ul, li {
    list-style: none;
    padding: 0;
    margin: 0;
  }
}

@keyframes notice-marquee {
  0% {
    transform: translateX(440px);
  }
  100% {
    transform: translateX(-100%);
  }
}
#monitor-modal {
  width: 100%;
  height: auto;
}
</style>
